import { create } from "zustand";
import { buildPortfolio } from "../data";
import type { Portfolio } from "../data/types";

interface PortfolioState {
  portfolio: Portfolio;
  rehydrate: () => void;
}

export const usePortfolioStore = create<PortfolioState>((set) => ({
  portfolio: buildPortfolio(),
  rehydrate: () => set({ portfolio: buildPortfolio() }),
}));
